import moment from "moment";

// A run of messages from one sender collapses under a single header, as long as
// they were sent close together.
export const GROUP_WINDOW_MINUTES = 5;

// Inside this window a message reads as "now" or "34 min"; past it, the clock.
export const RELATIVE_WINDOW_MINUTES = 60;

// `previous` is the chronologically earlier message, which in the newest-first
// list is the next item in the array.
export const startsGroup = (message, previous) => {
  if (!previous) {
    return true;
  }
  if (String(message.user_id) !== String(previous.user_id)) {
    return true;
  }
  if (Boolean(message.is_broadcast_message) !== Boolean(previous.is_broadcast_message)) {
    return true;
  }
  const gap = moment(message.created_on).diff(moment(previous.created_on), "minutes");
  // An unparseable timestamp gives NaN, which fails both bounds and so keeps
  // the header rather than silently swallowing the sender's name.
  return !(gap >= 0 && gap < GROUP_WINDOW_MINUTES);
};

// The caller translates: 'now' and 'minutes' carry no text of their own.
export const chatTimeParts = (timestamp, now = new Date()) => {
  const then = moment(timestamp);
  if (!then.isValid()) {
    return {kind: "exact", text: ""};
  }
  // A clock-skewed future timestamp lands here too, and reads as 'now'.
  const minutes = moment(now).diff(then, "minutes");
  if (minutes < 1) {
    return {kind: "now"};
  }
  if (minutes < RELATIVE_WINDOW_MINUTES) {
    return {kind: "minutes", minutes};
  }
  return {
    kind: "exact",
    text: then.isSame(moment(now), "day")
      ? then.format("h:mm a")
      : then.format("MMM D, h:mm a"),
  };
};

// Only a message still inside the relative window needs re-rendering as time
// passes; anything older shows a fixed clock time forever.
export const isRelativeTime = (timestamp, now = new Date()) =>
  chatTimeParts(timestamp, now).kind !== "exact";
